// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SwiperStyle } from "@eisinc/App/Components/XngCarousel";
import { ProductCarouselProductStyles } from "@eisinc/Overrides/Components/ProductCarouselProduct";
import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface SharedCarouselStyles {
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    carouselProductCondensedStyles?: ProductCarouselProductStyles;
    miniCardStyles?: ProductCarouselProductStyles;
    swiperStyles?: SwiperStyle;
    condensedSwiperStyles?: SwiperStyle;
}

export const sharedCarouselStyles: SharedCarouselStyles = {
    miniCardStyles: {
        productGridContainerStyles: {
            container: {
                css: css`
                    &&&& {
                        max-width: 328px;
                    }
                    display: grid;
                    grid-template-columns: 116px minmax(0, 1fr);
                    grid-template-rows: auto;
                    column-gap: 12px;
                    row-gap: 8px;
                    height: 100%;
                    & > .top-section {
                        grid-column: 1 / 2;
                        grid-row: 1 / 2;
                        margin-bottom: 0;
                    }
                    & > .middle-section {
                        grid-column: 2 / 3;
                        grid-row: 1 / 2;
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 0;
                    }
                    & > .bottom-section {
                        grid-column: 1 / 3;
                        grid-row: 2 / 3;
                    }
                `,
            },
            image: {
                css: css`
                    min-width: 116px;
                    max-width: 116px;
                    min-height: 116px;
                    max-height: 116px;
                `,
            },
            info: {
                css: css`
                    flex: 1;
                    ${GridWrapper} {
                        flex-grow: 0;
                        &:has(ul:empty) {
                            display: none;
                        }
                    }
                `,
            },
            addToCartActions: {
                css: css`
                    margin-top: auto;
                    > div {
                        margin-top: 4px;
                    }
                `,
            },
        },
    },
    carouselProductCondensedStyles: {
        productGridContainerStyles: {
            container: {
                css: css`
                    &&& {
                        max-width: 204px;
                    }
                `,
            },
            image: {
                css: css`
                    min-width: 204px;
                    max-width: 204px;
                    min-height: 204px;
                    max-height: 204px;
                `,
            },
            addToCartActions: {
                css: css`
                    margin-top: 8px;
                `,
            },
        },
    },
};
